import { render, staticRenderFns } from "./ProductPublishModal.vue?vue&type=template&id=bcba77c4&"
import script from "./ProductPublishModal.vue?vue&type=script&lang=js&"
export * from "./ProductPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports